export class OrdenCompraSeleccionadas {
    idOrdenCompra: number;
    montoCubierto: number;
    iva: number;
    retencion: number;
    subTotal: number;
    total: number;
    moneda:string;
    numero: string;
}